<div class="handover-filter-icon" [ngClass]="cssClass"></div> {{handoverType}}
